module.exports = __webpack_public_path__ + "static/img/nav.8a11b008.png";